import { render, staticRenderFns } from "./Summary20230220Page.vue?vue&type=template&id=c42b4560&scoped=true&"
import script from "./Summary20230220Page.vue?vue&type=script&lang=ts&"
export * from "./Summary20230220Page.vue?vue&type=script&lang=ts&"
import style0 from "./Summary20230220Page.vue?vue&type=style&index=0&id=c42b4560&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42b4560",
  null
  
)

export default component.exports